module.exports = __webpack_public_path__ + "img/Website-ad-1-nobadges.d86ff320.png";